import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import contactBg from "../images/NewUI/contact_bg.png";
import scheduleButton from "../images/NewUI/schedule_btn.png";
import BoldHeading from "./BoldHeading";
import Section from "./Section";
import Socials from "./Socials";

const ContactSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <>
      <Section py="0" sx={{ my: { xs: -20, sm: -16, md: -24 } }}>
        <img
          src={contactBg}
          alt=""
          width={lg ? "100%" : sm ? "120%" : "280%"}
          className="d-block"
          style={{
            maxWidth: "initial",
            position: "relative",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        />
      </Section>

      <Section containerClass="d-flex  align-center flex-wrap" py="0">
        <div
          className={md ? "col-8" : "col-12 d-flex flex-column align-center"}
        >
          <BoldHeading>Interested</BoldHeading>
          <Typography variant="h4" fontWeight="normal">
            in using NFT Gen2 for
          </Typography>
          <BoldHeading variant="h2" mb={2}>
            your business?
          </BoldHeading>
          <Button
            sx={{
              width: sm ? "50%" : "80%",
              maxWidth: "100%",
              p: 0,
              ml: md ? "-24px" : "",
            }}
            href="https://zeeg.me/sixnetwork"
            target="_blank"
          >
            <img src={scheduleButton} alt="" className="d-block" />
          </Button>
        </div>

        <Socials isVertical />
      </Section>
    </>
  );
};

export default ContactSection;
